const c = { cwd: n };
function n() {
  return "/";
}
export {
  c as minproc
};
//# sourceMappingURL=minproc.browser.js.map
